<script>
  import { getContext } from "svelte";
  import { line, curveLinear } from "d3-shape";
  import { fade } from "svelte/transition";

  const { data, xScale, yScale, height } = getContext("LayerCake");

  let { stroke = "#FFFFFF", curve = curveLinear } = $props();

  let path = $derived(
    line()
      .x((d) => $xScale(d.data.date))
      .y((d) => $yScale(d[1]))
      .curve(curve)
  );
  // .defined($y)
</script>

{#if $height > 0}
  <g class="line-group">
    {#each $data as group (group.key)}
      <path
        class="path-line"
        d={path(group)}
        {stroke}
        out:fade={{ delay: 0, duration: 200 }}
        in:fade={{ delay: 0, duration: 200 }}
      />
    {/each}
  </g>
{/if}

<style>
  .path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 1;
    transition: d 200ms ease-in-out;
  }
</style>
